module.exports = __webpack_public_path__ + "static/iPhone X Mockup1 (2)-b6b842c18a718d18384ee40d9f3707ca.png";